import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles';

export const MuiBadge = (theme: Theme): Components => ({
  MuiBadge: {
    styleOverrides: {
      badge: {
        paddingLeft: 5,
        paddingRight: 5,
        paddingTop: 1,
        paddingBottom: 1,
        fontSize: theme.typography.pxToRem(10),
        fontWeight: theme.typography.fontWeightBold,
        borderRadius: theme.shape.borderRadius,
        height: 16,
        minWidth: 15,
      },
      colorError: {
        color: theme.palette.common.white,
      },
    },
    defaultProps: {
      color: 'error',
      overlap: 'circular',
    },
  },
});
